import { useElementSize } from 'hooks/useElementSize'
import React, { RefObject, useEffect, useRef } from 'react'

import { HighlightData, WrappedSelectedTextItem } from './WrappedPage'

interface Props {
  item: {
    parent: WrappedSelectedTextItem
    children: WrappedSelectedTextItem[]
  }
  setHighlightsData: React.Dispatch<React.SetStateAction<HighlightData[]>>
  pageNumber: number
  pageRef: RefObject<HTMLDivElement> | null
  annotationIds: string[]
  discoveryIds: string[]
  id: string
}

const HighlightBase = ({
  item,
  setHighlightsData,
  pageNumber,
  pageRef,
  annotationIds,
  discoveryIds,
  id,
}: Props): JSX.Element => {
  const markRef = useRef(null)
  const markSize = useElementSize(markRef)
  const pagePosition = useElementSize(pageRef)

  useEffect(() => {
    if (markSize && markSize.x !== 0 && pagePosition && pagePosition.x !== 0) {
      const highlightData = {
        top: markSize.top - pagePosition.top,
        left: markSize.left - pagePosition.left,
        width: markSize.width,
        height: markSize.height,
        annotationIds: annotationIds,
        discoveryIds: discoveryIds,
      }
      setHighlightsData((prev) => [...prev, highlightData])
    }
  }, [
    setHighlightsData,
    pageNumber,
    markSize,
    pagePosition,
    annotationIds,
    discoveryIds,
  ])
  return (
    <div
      id={id}
      ref={markRef}
      style={{
        backgroundColor: 'transparent',
        whiteSpace: 'pre',
        color: 'transparent',
        display: 'inline-block',
      }}
    >
      {item.parent.item.item.str.substring(
        item.parent.item.startIndex,
        item.parent.item.stopIndex
      )}
    </div>
  )
}

export default HighlightBase
